import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import React from 'react';
import Input from './Input.react';
import hintContainer from '../containers/hintContainer';
import withClassNames from '../containers/withClassNames';
var HintedInput = hintContainer(Input);
export default withClassNames(function (_ref) {
  var inputRef = _ref.inputRef,
      props = _objectWithoutPropertiesLoose(_ref, ["inputRef"]);

  return /*#__PURE__*/React.createElement(HintedInput, _extends({}, props, {
    ref: inputRef
  }));
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-bootstrap-typeahead/es/components/TypeaheadInputSingle.react.js
// module id = 443
// module chunks = 31